import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import ParentFriends from './ParentFriends';
import ParentGroups from './ParentGroups';
import ParentChat from './ParentChat';

type SocialTab = 'friends' | 'chat';

const ParentSocial: React.FC = () => {
  const [params] = useSearchParams();
  const [tab, setTab] = useState<SocialTab>(
    params.get('tab') === 'chat' || params.get('cid') ? 'chat' : 'friends'
  );

  // switch to the chat sub-tab when navigated here with chat params
  useEffect(() => {
    if (params.get('tab') === 'chat' || params.get('cid')) setTab('chat');
  }, [params]);

  return (
    <div className="space-y-5">
      {/* Sub-tab switcher */}
      <div className="flex gap-2 bg-white/70 backdrop-blur rounded-full p-1 shadow-sm">
        <button
          onClick={() => setTab('friends')}
          className={`kt-tab flex-1 ${tab === 'friends' ? 'bg-brand-purple text-white shadow' : 'text-gray-500'}`}
        >
          🤝 Friends &amp; Groups
        </button>
        <button
          onClick={() => setTab('chat')}
          className={`kt-tab flex-1 ${tab === 'chat' ? 'bg-brand-blue text-white shadow' : 'text-gray-500'}`}
        >
          💬 Chat
        </button>
      </div>

      {tab === 'friends' ? (
        <div className="space-y-6">
          <ParentFriends />
          <ParentGroups />
        </div>
      ) : (
        <ParentChat />
      )}
    </div>
  );
};

export default ParentSocial;
